import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarCheck, Plus } from "lucide-react";
import apiClient from "../../utils/apiClient";
import InterviewList from "./InterviewList";
import { PageHeader, AppButton } from "../ui";
import { getCurrentUser } from "../../utils/auth";

const StudentInterviewsPage = () => {
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [canSchedule, setCanSchedule] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInterviews = async () => {
      setLoading(true);
      try {
        const user = getCurrentUser();
        const studentId = user?.studentId;
        if (!studentId) {
          setInterviews([]);
          setLoading(false);
          return;
        }
        const { data } = await apiClient.get(`/interviews/student/${studentId}`);
        setInterviews(data.interviews || []);
      } catch {
        setInterviews([]);
      }
      setLoading(false);
    };
    fetchInterviews();
  }, []);

  useEffect(() => {
    apiClient.get('/institute/config')
      .then(res => setCanSchedule(!!res.data?.config?.studentSelfScheduling))
      .catch(() => setCanSchedule(false));
  }, []);

  return (
    <div className="iv-page">
      <PageHeader
        title="My Interviews"
        description="Track your interview schedules and status"
        icon={CalendarCheck}
        actions={
          canSchedule && (
            <AppButton onClick={() => navigate('/s/interviews/new')}>
              <Plus size={16} />
              <span>Schedule Interview</span>
            </AppButton>
          )
        }
      />
      <InterviewList
        data={interviews}
        loading={loading}
        isStudentView
        readOnly
        basePath="/s/interviews"
      />
    </div>
  );
};

export default StudentInterviewsPage;
